export class TrackingType {
    id: string;
    loginDetailId: string;
    timedOut: boolean;
    roleId: number;
    routes: Route[] = [];
    refreshed: boolean;
    kickedOut: boolean;
    kickedSession: string;

    constructor(init?: Partial<TrackingType>) {
        Object.assign(this, {
            // Defaults
            timedOut: false,
            refreshed: false,
            kickedOut: false,
            kickedSession: '',
            ...init
        });

        this.timedOut = this.timedOut ?? false;
        this.refreshed = this.refreshed ?? false;
        this.kickedOut = this.kickedOut ?? false;
        this.kickedSession = this.kickedSession ?? '';
    }
}

export class Route {
    path: string = '';
    timeStamp: string = '';
    bLastVisited: boolean = false;
    searchCriterias: SearchCriteria[] = [];
    searchResults: SearchResult[] = [];
    chosenResults: SearchResult[] = [];

    constructor(init?: Partial<Route>) {
        Object.assign(this, init);
    }
}

export interface SearchCriteria {
    screenName: string;
    payLoad: string;
}

export interface SearchResult {
    screenName: string;
    results: Result[];
}

export interface Result {
    ID: number;
}
